import { useEffect, useState } from 'react';
import { HoldbackForm } from './HoldbackForm';
import { useLoadBalance } from 'pages/finance/modules/balance/hooks/useLoadBalances';
import SelectItem from 'types/SelectItem';
import { upsertHoldback } from 'api/holdbacks';
import { closeModal } from 'actions/modal';
import { useDispatch } from 'react-redux';
import { getHoldbackList } from 'api/holdbacks';
import { saveDataState } from 'actions/getData';
import { HoldbackFormState } from './types';
import { HoldbackData } from 'pages/finance/modules/holdbacks/types';

interface HoldbackFormContainerProps {
  content?: {
    holdbackData?: HoldbackData;
  };
}

const HoldbackFormContainer = ({
  content,
}: HoldbackFormContainerProps) => {
  const dispatch = useDispatch();
  const [balances, setBalances] = useState<SelectItem[]>([]);

  const holdbackData = content?.holdbackData;
  const isEditMode = !!holdbackData;

  const { isLoading, balanceList } = useLoadBalance();

  useEffect(() => {
    setBalances(
      balanceList.flatMap((curr) =>
        curr.rows.map((row) => ({
          value: row.balanceId,
          label: row.balanceTitle,
          currency: row.currency,
          contractConditions: (row.contractConditions || []).map(
            (contractCondition) => ({
              value: contractCondition.id,
              label: contractCondition.title,
            })
          ),
        }))
      )
    );
  }, [balanceList]);

  const onSubmit = async (form: HoldbackFormState) => {
    try {
      await upsertHoldback({
        id: holdbackData?.id,
        balanceId: Number(form.balance?.value),
        holdType: form.holdType,
        holdFix: parseFloat(form.holdFix) || 0,
        holdPercent: parseFloat(form.holdPercent) || 0,
        holdPercentPeriod: Number(form.holdPercentPeriod) || 0,
        contractConditionsId: Number(form.contractConditions?.value) || 0,
        status: form.status,
        comment: form.comment,
        ...(form.dateEnd && {
          dateEnd: form.dateEnd
        }),
        dateStart: form.dateStart
      });
      dispatch(saveDataState('holdbacks', { isFetch: true }));
      getHoldbackList();
      dispatch(closeModal());
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <HoldbackForm
      isLoading={!isLoading}
      balances={balances}
      isEditMode={isEditMode}
      holdbackData={holdbackData}
      onSubmit={onSubmit}
    />
  );
};
export default HoldbackFormContainer;
